import React from "react";
import { variablesGlobales } from "../../configs/variables";

export const Primary = (props) => {
  const isPayWompi = props.isPaymentWompi;

  return (
    <div>
      {isPayWompi ? (
        <a
          href={`${
            variablesGlobales.urlServiceBackend
          }/api/v1/wompi/checkout?value1=${btoa(props.doc)}&value2=${btoa(
            props.credit_id
          )}&value3=${btoa(props.amount)}`}
          target="_blank"
        >
          <button
            type="button"
            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-xl text-white bg-green transition duration-300 hover:bg-greenDark focus:outline-none"
          >
            <div className="flex">
              {props.text}
              <div className="grid content-center pl-2">{props.icon}</div>
            </div>
          </button>
        </a>
      ) : (
        <button
          type="submit"
          className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-lg text-white font-semibold bg-purple transition duration-300 hover:bg-purpleDark focus:outline-none"
        >
          <div className="flex">
            {props.text}
            <div className="grid content-center pl-2">{props.icon}</div>
          </div>
        </button>
      )}
    </div>
  );
};
